import React, { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import validator from 'validator';
import axios from 'axios';
import { Box, CircularProgress } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ForgetPasswordMessage from './Forget_password_message';
import { urlConfig } from '../../../config/urlConfig';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.ui.secondary,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  link: {
    color: theme.ui.secondary,
    textDecoration: 'none',
    backgroundColor: '#fff',
    marginRight: 3,
    marginLeft: 3,
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  wrapper: {
    margin: '24px 0',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function Forget_password() {
  const classes = useStyles();
  const emailRef = useRef(null);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [emailIsValid, setEmailIsValid] = useState('');
  const [loading, setLoading] = useState(false);
  const [renderComponent, setRenderComponent] = useState(true);

  const submitHandler = (e) => {
    e.preventDefault();

    setEmailError(false);
    if (validator.isEmpty(email)) {
      setEmailError(true);
      emailRef.current.focus();
    }
    if (!validator.isEmpty(email) && !validator.isEmail(email)) {
      emailRef.current.focus();
      setEmailIsValid(' Enter valid Email address! ');
    }

    const data = {
      email,
    };

    if (!validator.isEmpty(email) && validator.isEmail(email)) {
      setLoading(true);
      axios
        .post(urlConfig.reset_password_url, data)
        .then((res) => {
          setLoading(false);
          setRenderComponent(false);
        })
        .catch((err) => {
          setLoading(false);
          setEmailIsValid(err.toString());
          err.response &&
            err.response.data &&
            err.response.data.email &&
            setEmailIsValid(err.response.data.email.toString());
        });
    }
  };

  return (
    <Container component='main' maxWidth='xs'>
      {renderComponent ? (
        <div className={classes.paper}>
          <Typography variant='h4' gutterBottom>
            Forgot your password?
          </Typography>
          <Typography variant='body2' gutterBottom>
            Enter your e-mail address below, and we'll send you an e-mail
            allowing you to reset it.
          </Typography>
          <form
            className={classes.form}
            noValidate
            autoComplete='off'
            onSubmit={submitHandler}
          >
            <TextField
              size='small'
              variant='outlined'
              margin='normal'
              required
              fullWidth
              id='email'
              type='email'
              label='Email Address'
              name='email'
              inputRef={emailRef}
              error={emailError}
              helperText={
                <Typography color='error' variant='caption'>
                  {emailIsValid}
                </Typography>
              }
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              autoFocus
            />
            <Box className={classes.wrapper}>
              <Button
                type='submit'
                fullWidth
                variant='contained'
                color='primary'
                className={classes.submit}
                disabled={loading}
              >
                Send
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </Box>
            <Typography variant='caption' color='textSecondary'>
              Please
              <Link
                to='/contact'
                onClick={() => setRenderComponent(true)}
                className={classes.link}
              >
                contact us
              </Link>
              if you have any trouble resetting your password.
            </Typography>
          </form>
        </div>
      ) : (
        <ForgetPasswordMessage />
      )}
    </Container>
  );
}
